var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaxSelectionMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21582 2.62876C8.12176 2.45708 7.87824 2.45708 7.78418 2.62876L2.03143 13.1281C1.94 13.2949 2.059 13.5 2.24725 13.5H13.7528C13.941 13.5 14.06 13.2949 13.9686 13.1281L8.21582 2.62876ZM7.5 9.8V6.5H8.5V9.8H7.5ZM7.99999 11.7C7.66862 11.7 7.39999 11.4314 7.39999 11.1C7.39999 10.7686 7.66862 10.5 7.99999 10.5C8.33136 10.5 8.59999 10.7686 8.59999 11.1C8.59999 11.4314 8.33136 11.7 7.99999 11.7Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaxSelectionMessageIcon);
export default __webpack_public_path__ + "static/media/max-selection-message-icon.94b27bbd53cc9f86ff1e529571217652.svg";
export { ForwardRef as ReactComponent };